export function createAsyncAction(key) {
  const pendingType = `${key}_pending`;
  const fulfilledType = `${key}_fulfilled`;
  const rejectedType = `${key}_rejected`;
  return function () {
    function pending(payload) {
      return {
        type: pendingType,
        payload
      };
    }
    pending.type = pendingType;
    function fulfilled(payload) {
      return {
        type: fulfilledType,
        payload
      };
    }
    fulfilled.type = fulfilledType;
    function rejected(error) {
      return {
        type: rejectedType,
        payload: error
      };
    }
    rejected.type = rejectedType;
    return {
      pending,
      fulfilled,
      rejected
    };
  };
}